import React from 'react';
import { Row, Col } from 'react-bootstrap';

// import ListResources from './resources/ListResources';
// import Streams from './container/Streams';
// import InstancesBlock from './instances/InstancesBlock';
import { Link } from 'react-router-dom'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

import DeployedRegions from './regions/DeployedRegions';

function APMDashboard(props) {
    return (
        <>
        <Breadcrumb>
                    <Breadcrumb.Item href="">
                        <Link to='navigate_new'>Home</Link></Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        <Link to='/welcome'>Welcome</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href=""  >
                        <Link to='/close_loop'>Close loop</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="/close_loop/real_time/apm/dashboard" active >
                        Docker Status
                    </Breadcrumb.Item>
                </Breadcrumb>
            <Row style={{ "paddingTop": "1%" }}>
                <Col>
                    <h2 style={{ fontWeight: "1000" }}>
                        APM Dashboard
                    </h2>
                </Col>
            </Row>
            {/* <Row style={{ "paddingTop": "1%" }}>
                <Col xs lg={4}>
                    <InstancesBlock />
                </Col>
                <Col xs lg={8}>
                    <ListResources />
                    <Streams />
                </Col>
            </Row> */}
            <Row>
                <Col xs lg={12}>
                    <DeployedRegions {...props} />
                </Col>
            </Row>
        </>
    )
}

export default APMDashboard;